import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 divide-y divide-background-200 overflow-hidden">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="w-full flex items-start justify-between gap-4 px-5 md:px-7 py-5 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-bold text-foreground-950">{item.q}</span>
                <span
                  className={`flex w-7 h-7 shrink-0 items-center justify-center rounded-md transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 md:px-7 pb-5 -mt-1">
                <p className="text-sm leading-relaxed text-foreground-600 max-w-3xl">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}